import {useSelector} from 'react-redux';

export default function useUser() {
  const authenticationState = useSelector((state: any) => state.authentication);
  return authenticationState.user.name;
}
